import { useEffect, useState } from "react";
import Pagination from "../ecommerce/Pagination";
import SingleProduct from "../ecommerce/singleProduct/SingleProduct";
import TableTypeList from "../products/list/TableTypeList";
import * as F from "./FilterList.styles";
import { useRouter } from "next/router";

const FilteredList = (props) => {
  const {
    viewType,
    handleListViewType,
    dummyList,
    filteredList,
    addCart,
    inCart,
  } = props;
  const router = useRouter(),
    limit = 12,
    showPagination = 5;
  const [pagination, setPagination] = useState([]);
  const [paginatedList, setPaginatedList] = useState([]);
  const pages = filteredList && Math.ceil(filteredList.length / limit);

  // pagination
  const createPagination = () => {
    let arr = new Array(pages).fill().map((_, idx) => idx + 1);
    setPagination(arr);
  };

  const startIndex =
    (router.query.page ? Number(router.query.page) : 1) * limit - limit;
  const endIndex = startIndex + limit;

  let start =
    Math.floor(
      ((router.query.page ? router.query.page : 1) - 1) / showPagination
    ) * showPagination;
  let end = start + showPagination;

  const getPaginationGroup = pagination.slice(start, end);

  // 페이지 네이션
  const next = () => {
    sessionStorage.setItem(
      `__next_scroll_${router.pathname}`,
      JSON.stringify({
        x: window.scrollX,
        y: window.scrollY,
      })
    );
    router.push({
      pathname: "",
      query: {
        ...router.query,
        page: start + 6,
      },
    });
  };

  const prev = () => {
    sessionStorage.setItem(
      `__next_scroll_${router.pathname}`,
      JSON.stringify({
        x: window.scrollX,
        y: window.scrollY,
      })
    );
    router.push({
      pathname: "",
      query: {
        ...router.query,
        page: start,
      },
    });
  };

  const handleActive = (page) => {
    sessionStorage.setItem(
      `__next_scroll_${router.pathname}`,
      JSON.stringify({
        x: window.scrollX,
        y: window.scrollY,
      })
    );
    router.push({
      pathname: "",
      query: {
        ...router.query,
        page: page,
      },
    });
  };

  useEffect(() => {
    if (filteredList) {
      createPagination();
      setPaginatedList(filteredList.slice(startIndex, endIndex));
    }
  }, [filteredList, router.query.page]);

  return (
    <>
      <F.ListWrapper
        style={{
          borderBottom: "none",
        }}
      >
        <F.ListSortWrapper>
          <div></div>
          <F.ListViewTypeWrapper>
            <div className="me-2">총 {filteredList.length}개의 상품</div>
            <F.ListViewSelectBox listViewType={viewType ? viewType : "grid"}>
              <span
                className={!viewType || viewType === "grid" ? "selected" : ""}
                onClick={() => handleListViewType("grid")}
              >
                <i className="fi-rs-grid" />
              </span>
              <span
                className={viewType && viewType === "list" ? "selected" : ""}
                onClick={() => handleListViewType("list")}
              >
                <i className="fi-rs-list" />
              </span>
            </F.ListViewSelectBox>
          </F.ListViewTypeWrapper>
        </F.ListSortWrapper>
        <F.ProductsWrapper>
          {(!viewType || viewType === "grid") && (
            <F.ProductsGrid>
              {paginatedList &&
                paginatedList.map((item, i) => (
                  <div key={i}>
                    <SingleProduct
                      product={item}
                      dummyList={dummyList}
                      addCart={addCart}
                      inCart={inCart}
                    />
                  </div>
                ))}
            </F.ProductsGrid>
          )}
          {viewType && viewType === "list" && (
            <>
              {
                <TableTypeList
                  productList={paginatedList}
                  dummyList={dummyList}
                  addCart={addCart}
                  inCart={inCart}
                  viewFeature={true}
                />
              }
            </>
          )}
        </F.ProductsWrapper>
        {
          <div className="pagination-area mb-15">
            <nav aria-label="Page navigation">
              <ul className="pagination justify-content-center">
                {start == 0 || getPaginationGroup.length <= 0 ? null : (
                  <li onClick={prev} className="page-item">
                    {(router.query.page ? router.query.page : 1) == 1 ? null : (
                      <a className="page-link">
                        <i className="fi-rs-angle-double-small-left"></i>
                      </a>
                    )}
                  </li>
                )}

                {getPaginationGroup.map((item, index) => {
                  return (
                    <li
                      onClick={() => handleActive(item)}
                      key={index}
                      className={
                        (router.query.page ? router.query.page : 1) == item
                          ? "page-item active"
                          : "page-item"
                      }
                    >
                      <a className="page-link">{item}</a>
                    </li>
                  );
                })}
                {getPaginationGroup.length <= 0 ||
                pages <= 5 ||
                end > pages ? null : (
                  <li onClick={next} className="page-item">
                    {(router.query.page ? router.query.page : 1) >=
                    pages ? null : (
                      <a className="page-link">
                        <i className="fi-rs-angle-double-small-right"></i>
                      </a>
                    )}
                  </li>
                )}

                {getPaginationGroup.length <= 0 ? null : (
                  <li className="d-none d-md-flex align-items-center ml-10">
                    총 {pages} 페이지
                  </li>
                )}
              </ul>
            </nav>
          </div>
        }
      </F.ListWrapper>
    </>
  );
};
export default FilteredList;
